<template>
    <emc-form-base 
        :show.sync="dialog"
        @onOk="submit"
        maxWidth='20%'
        icon="mdi-file-excel"
        textButton="Download"
        iconButton="mdi-microsoft-excel"
        colorButton="success"
    >
        <template v-slot:form>
            <v-form ref="form">
                <v-text-field
                    v-show="showYear"
                    ref="year"
                    v-model="year"
                    label="Ano"
                    outlined
                    :rules="[() => !!year || 'Informe o ano']"
                    required
                />
                <v-combobox
                    ref="select"
                    v-model="selecteds"
                    :items="items"
                    item-key="id"
                    item-text="name"
                    :rules="[() => selecteds.length > 0 || 'Selecione o(s) mês(es)']"
                    outlined
                    label="Selecione os meses"
                    required
                    multiple
                    small-chips
                    clearable
                />
            </v-form>
        </template>
    </emc-form-base>
</template>

<script>
import { myMixin } from '../../../../src/mixins.js'
import state from '../../../modules/auth/store/state'
export default {
    name: "SysPrintPaymentExport",
    mixins: [myMixin],
    data: () => ({
        dialog: false,
        year: null,
        selecteds: [],
        formHasErrors: false,
        showYear: false,
        items: [ 
                { id:1,     name: 'Janeiro' },
                { id:2,     name: 'Fevereiro' },
                { id:3,     name: 'Março' },
                { id:4,     name: 'Abril' },
                { id:5,     name: 'Maio' },
                { id:6,     name: 'Junho' },
                { id:7,     name: 'Julho' },
                { id:8,     name: 'Agosto' },
                { id:9,     name: 'Setembro' },
                { id:10,    name: 'Outubro' },
                { id:11,    name: 'Novembro' },
                { id:12,    name: 'Dezembro' },
            ],
        
    }),

    computed: {
      
      form () {
        return {
          year:         this.year,
          select:       this.selecteds,
        }
      },
    },
    watch: {

        
        
        show(val){
            
            this.dialog = val;
            
            if(val){
                this.selecteds = [];
                var month = new Date().getMonth() + 1;
                this.year = state.acesso.periodo.year;
                this.selecteds.push(this.items.find(i => i.id == month))
            }
        },

        dialog(val){
            this.$emit('update:show', val);
        },
        
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
    },

    methods: {
        submit () {
            
            this.formHasErrors = false;

            Object.keys(this.form).forEach(f => {
            
            if (!this.form[f]){
                this.formHasErrors = true;
            }
                this.$refs[f].validate(true);
            });

            if(!this.formHasErrors && this.selecteds.length > 0){
                
                var months = this.selecteds.map(o => o.id);
                this.download(32, 'options[year]='+ this.year + '&options[months]=' + months);
            }
      },
    }
}
</script>